import { render, staticRenderFns } from "./SettingPlanQ.vue?vue&type=template&id=47e1659f&scoped=true&"
import script from "./SettingPlanQ.vue?vue&type=script&lang=js&"
export * from "./SettingPlanQ.vue?vue&type=script&lang=js&"
import style0 from "./SettingPlanQ.vue?vue&type=style&index=0&id=47e1659f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e1659f",
  null
  
)

export default component.exports